export enum ECurrency {
  BYN = "BYN",
  RUB = "RUB",
  USD = "USD",
  EUR = "EUR",
  KZT = "KZT",
  YUNIT = "YUNIT",
  YUN = "YUN",
}
